
import React, { Component } from "react";
import Chart from "react-apexcharts";
import urls from '../../custom_libraries/urls';
import globalVariables from "../../custom_libraries/globalVariables";
import { post, get, getFreshToken } from '../../custom_libraries/serverRequests';
import { Button} from '@mui/material';
import ReportDownloadIcon from "../../assets/icons8-download-report-48.png"
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Navigationbar from '../Navigationbar';
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import withNavigate from "../../Global_files/WithNavigate";

class BySites extends Component {
  constructor(props) {
    super(props);

    this.state = {
      site_list:[],
      devices:[],
      cameras:[],
      sitename:'',
      devicename:'',
      pdf_path :'',
      siteId: null,
      deviceId: null,
      cameraId: null,
      setPdf : null,
      warning : false ,
      warning1: false,
      error : false,
      open_progress_bar: false,

      options: {
        chart: {
          id: "Camera-matrix"
        },
        title: {
          text: "Performance and Health of Camera Systems", // Add your label here
          align: "center", // Align the title (options: 'left', 'center', 'right')
          style: {
            fontSize: "16px", // Adjust font size
            fontWeight: "bold", // Adjust font weight
            color: "#333", // Adjust title color
          },
        },
        xaxis: {
          categories: ["Cameras\nOnline", "Cameras\nRecording", "Camera\nRetension", "Hard\nDrives ok", "Clock\ncorrect"]
        },
        plotOptions: {
          bar: {
            // horizontal: true,
            distributed: false, // This makes each bar have its own color
          }
        },
        colors: [ "#00E396"]
      },
      series: [
        {
          name: "Count",
          data: [0, 0, 0, 0, 0]
        }
      ],

      options1: {
        chart: {
          id: "Image-quality-assessment"
        },
        title: {
          text: "Image Quality Assessment with counts", // Add your label here
          align: "center", // Align the title (options: 'left', 'center', 'right')
          style: {
            fontSize: "16px", // Adjust font size
            fontWeight: "bold", // Adjust font weight
            color: "#333", // Adjust title color
          },
        },
        xaxis: {
          categories: ["Healthy", "Not Rated by Operator", "Blocked", "Blurred", "Low Light", "Tilted / FOV", "Muted"]
        },
        plotOptions: {
          bar: {
            horizontal: true,
            distributed: false, // This makes each bar have its own color
          }
        },
        colors: [ "#FEB019"]
      },
      series1: [
        {
          name: "Count",
          data: [0, 0, 0, 0, 0, 0, 0]
        }
      ]
    };
  }

 async componentDidMount(){
    setTimeout(() => {
      this.validateSignedIn();
    }, 0);
    this.getReportData();
    this.getSitesList();
    // this.getDevicesList();
    // this.getCamerasList();
  }

  validateSignedIn = async () => {
    try {
      let is_fresh_token = await getFreshToken();
      console.log("Fresh Token:", is_fresh_token);
  
      if (!is_fresh_token) {
        console.log("Navigating to login...");
        this.props.navigate("/");
        return;
      }
    } catch (error) {
      console.error("Error in validateSignedIn:", error);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.warning !== prevState.warning ||
        this.state.error !== prevState.error
    ) {
        if (
            this.state.warning ||
            this.state.error 
        ) {
            setTimeout(() => {
                this.setState({
                  warning : false ,
                  error : false,
                });
            }, 4000); // 1 second
        }
    }
}

      getSitesList = async () => {
          try {
              let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
              console.log("--------auth tocken---------", access_tocken);
              let headers = {
                  'content-type': 'application/json',
                  'Authorization': `Bearer ${access_tocken}`
              }
  
              console.log("Fetching data from:", urls.GET_SITES_BY_USER); // Update URL for fetching sites
              const response = await get(urls.GET_SITES_BY_USER, headers);
              console.log("response===> ", response);
  
              if (!response) {
                  console.error("Failed to fetch site list.");
                  this.setState({ site_list: [] });
                  return;
              }
  
              this.setState({ site_list: response });
          } catch (error) {
              console.error("Error in getSitesList:", error);
              this.setState({ site_list: [] });
          }
      };


      getDevicesListById = async (site_id) => {
          // let site_id = localStorage.getItem(globalVariables.SITE_ID);
          // this.setState({ site_id: site_id });
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          console.log("---------globalVariables site_id--------", site_id);
          try {
            const url = urls.GET_DEVICES_BY_SITE(site_id);
            const response = await get(url, headers); // Replace with your actual API call
            console.log("url----------->", url);
            console.log("API Response:----------getDevicesListById site_id--------------------------------->>>", response)
      
            if (response) {
              console.log("res",response)
              this.setState({ devices: response });
              // this.setState({ devices:deviceData });
              // this.setState({ deviceId:deviceData.id });
            }
            else {
              console.error("No data returned from the API");
              this.setState({ devices: [] });
            }
          } catch (error) {
            console.error("Error fetching devices from API:", error);
          }
        };

      getCamerasListByDeviceId = async (deviceId) => {
        try {
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'content-type': 'application/json',
              'Authorization': `Bearer ${access_tocken}`
          }
          
          console.log("deviceId -------------->:", deviceId);
          //this.setState({ : [] }); 
          
          const url = urls.CAMERAS_BY_DEVICE(deviceId);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
          const response = await get(url, headers); // Perform the API call using the constructed URL
          console.log(`API Response for device ${deviceId}:`, response);
          if (Array.isArray(response)) {
            console.log(`API Response for device ${deviceId}:`, response);
            this.setState({ cameras: response });
    
          } else {
            console.error("No valid data returned from the get-camera API");
            this.setState({ cameras: [] }); // Ensure cameras list is cleared for invalid data
          }
        } catch (error) {
          console.error("Error fetching cameras from API:", error);
          this.setState({ cameras: [] }); // Clear the cameras list in case of error
        }
      };


      handleInputChange = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "sitename") {
          // When a site is selected, fetch the devices for that site
          this.setState({
            siteId: value,
            devicename: "", // Clear selected device
            deviceId: "",   // Reset device ID
            // cameraName: "", // Clear selected camera
            cameraId: "",   // Reset camera ID
          })
          await this.getDevicesListById(value);
        }
        if (name === "devicename") {
          // if(value === ""){
          //   // this.setState({deviceId: value})
          //   await this.getCamerasListByDeviceId();
          // }
          // When a site is selected, fetch the devices for that site
          await this.getCamerasListByDeviceId(value);
          this.setState({deviceId: value})
        }
        if (name === "cameraName") {
          // When a site is selected, fetch the devices for that site
          this.setState({cameraId: value})
        }
      };

      clearFilter = async () => {
        this.setState({
          sitename: "",
          devicename: "",
          cameraName: "",
          siteId: null,
          deviceId: null,
          cameraId: null,
          pdf_path: null,
          warning: false,
          warning1: false,
          error: false
        });
        setTimeout(() => {
        this.getReportData();
        },500);
      }

      getReportData = async() => {
        const {siteId, deviceId, cameraId} = this.state
        let data = { }
        if (siteId) {
          // Add cameraId only if selected
          data.sitedb = siteId;
        }
        if (cameraId) {
          // Add cameraId only if selected
          data.cameras = [cameraId];
        }

        if (deviceId) {
          // Add cameraId only if selected
          data.device = deviceId;
        }
        data = JSON.stringify(data);
        console.log("----post data in fetch report----", data);

        try {
          this.startLoading();
          let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
          console.log("--------auth tocken---------", access_tocken);
          let headers = {
              'Content-Type': 'application/json', // Expecting a JSON response',
              'Authorization': `Bearer ${access_tocken}`
          }
          const response = await post(urls.GENERATE_REPORT, data, headers); // Replace with your actual API call
          console.log("API Response getReportData:", response);
          console.log("API Response.report_file:", response.report_file);
          this.stopLoading();
          if (response && response.matrix_data) {

            this.setState({ pdf_path: response.report_file });
           // Extract camera_view_results from matrix_data
            const { camera_matrix_results } = response.matrix_data;
            console.log("--------camera_matrix_results-----------:", camera_matrix_results);
            console.log("--------response.matrix_data.live_cameras_count-----------:", response.matrix_data.live_cameras_count);
            // Map the data for the chart
            const chartData = [
              response.matrix_data.live_cameras_count || 0,       // Cameras Online
              response.matrix_data.cameras_with_last24h_recording || 0,  // Cameras Recording
              response.matrix_data.retention_days || 0,           // Camera Retention
              // response.matrix_data.hdd_status === "ok" ? 1 : 0, // Hard Drives ok (1 for "ok", 0 for not)
              parseInt(response.matrix_data.hdd_status.split('/')[0], 10),
              response.matrix_data.timezone_match ? 1 : 0    // Clock correct (1 for true, 0 for false)
            ];
            
            const cameraRatingChart = [
              // response.matrix_data.camera_view_results.ai_rating.block,       // AI rating Cameras Block
              // response.matrix_data.camera_view_results.ai_rating.healthy,       // Cameras Healthy
              response.matrix_data.camera_view_results.ai_rating.healthy || 0,
              response.matrix_data.camera_view_results.operator_rating["not yet rated"] || 0,
              response.matrix_data.camera_view_results.ai_rating.block || 0,
              response.matrix_data.camera_view_results.ai_rating.blur || 0,
              response.matrix_data.camera_view_results.ai_rating["low light"] || 0,
              response.matrix_data.camera_view_results.ai_rating.tilt || 0,
              response.matrix_data.camera_view_results.ai_rating.mute || 0,
            ]
            // console.log("hello", response.matrix_data.camera_view_results.ai_rating.healthy);
            // Update the chart's series with the fetched data
            this.setState({
                series: [
                    {
                        name: "Count",
                        data: chartData
                    }
                ],
                series1: [
                  {
                      name: "Count",
                      data: cameraRatingChart
                  }
              ]
            });
          }
          else if (response.error === 'No devices found for the provided criteria'){
            this.setState({warning:true})
            const chartData = [0, 0, 0, 0, 0];
            const cameraRatingChart = [0, 0, 0, 0, 0, 0, 0];
            // Update the chart's series with the fetched data
            this.setState({
              series: [
                  {
                      name: "Count",
                      data: chartData
                  }
              ],
              series1: [
                {
                    name: "Count",
                    data: cameraRatingChart
                }
            ],
          });
          }

          else if (response.error === 'No sites found for the user'){
            this.setState({warning1:true})
            const chartData = [0, 0, 0, 0, 0];
            const cameraRatingChart = [0, 0, 0, 0, 0, 0, 0];
            // Update the chart's series with the fetched data
            this.setState({
              series: [
                  {
                      name: "Count",
                      data: chartData
                  }
              ],
              series1: [
                {
                    name: "Count",
                    data: cameraRatingChart
                }
            ],
          });
          }
          
          else {
            console.error("No data returned from the API");
            this.setState({warning: true,
              series: [{name: "Count",  data: [0, 0, 0, 0, 0] }],
              series1: [{name: "Count", data: [0, 0, 0, 0, 0, 0, 0] }]
            })
          }
        } catch (error) {
          console.error("Error fetching devices from API:", error);
        }
      }

      DownloadReport = async () => {
        const { pdf_path } = this.state;
        this.startLoading();

        if (!pdf_path) {
          console.error("PDF file path is not available");
          return;
        }
      
        try {
          // Prepare the request body
          const data = JSON.stringify({ pdf_file_path: pdf_path });
      
          // Retrieve the access token
          const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      
          // Define headers
          const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${access_token}`,
          };
      
          // Make the POST request
          const response = await fetch(urls.DOWNLOAD_REPORTS, {
            method: 'POST',
            headers: headers,
            body: data,
          });
          if (!response.ok) {
            throw new Error(`Failed to fetch the PDF file: ${response.statusText}`);
          }
          // Convert the response to a Blob
          const blob = await response.blob();
      
          // Create an object URL for the Blob
          const url = URL.createObjectURL(blob);
      
          // Open the PDF in a new tab for preview
          window.open(url, '_blank');
      
          console.log("PDF preview opened successfully");
          this.stopLoading();
      
        } catch (error) {
          console.error("Error fetching the PDF file:", error);
        }
      };

      startLoading = () => {
        console.log("startloading")
    
        this.setState({ open_progress_bar: true })
    }
    
    stopLoading = () => {
        this.setState({ open_progress_bar: false })
    }
      
  render() {
    const{site_list, sitename, devices, cameras, devicename, cameraName, error, warning, warning1} = this.state
    return (
      <div>
        <Navigationbar />
      <div className="app" style={{marginRight:'40px', marginLeft:'8%'}}>
        <div className="graph_selection_boxes" style={{display:'flex', justifyContent:'right', gap:'15px', marginTop:'40px'}}>
          <select
                name="sitename"
                // title="If you cannot find a device type, contact the admin"
                value={sitename}
                onChange={this.handleInputChange}
                style={{ width: '23%', padding: '8px', fontSize:'13px', height:'34px' }}
              >
                <option value="" disabled>Select site to view details</option>
                {site_list.map((type) => (
                    <option key={type.id} value={type.id}>
                        {type.sitename}
                    </option>
                ))}
          </select>
          {sitename && (
          <select
                name="devicename"
                // title="If you cannot find a device type, contact the admin"
                value={devicename}
                onChange={this.handleInputChange}
                style={{ width: '23%', padding: '8px', fontSize:'13px', height:'34px' }}
              >
                <option value="" disabled>Select device to view details</option>
                {Array.isArray(devices) ? (
                    devices.map((type) => (
                      <option key={type.id} value={type.id}>
                        {type.device_name}
                      </option>
                    ))
                  ) : (
                    <option value="" disabled>
                      No device found
                    </option>
                  )}
           </select>
          )}
          {sitename && devicename && (
           <select
              name="cameraName"
              value={cameraName}
              onChange={this.handleInputChange}
              style={{ width: '23%', padding: '8px', fontSize: '13px', height: '34px' }}
            >
              <option value="" disabled>Select camera to view details</option>
              {Array.isArray(cameras) ? (
                cameras.map((camera) => (
                  <option key={camera.id} value={camera.id}>
                    {camera.camera_name}  {/* Adjust this based on your actual data structure */}
                  </option>
                ))
              ) : (
                <option value="" disabled>No cameras found</option>
              )}
            </select>
          )}

           <Button id="rowsPerPageButton" 
              style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
              onClick={this.getReportData}
           >Apply
           </Button>

           <Button id="clearUserLogButton" 
              style={{fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center", margin:'0px'}}
              onClick={this.clearFilter}
           >Clear
           </Button>

           {/* <Button style={{backgroundColor:'#848c95', color:'white', fontSize:'12px', fontWeight:'bold', height: "34px", display: "flex", alignItems: "center"}}>Download Report</Button> */}
          <img src={ReportDownloadIcon} alt="report-download" width="40px" height="40px" title="Download Report" style={{cursor:'pointer'}} onClick={this.DownloadReport} />
        </div>
        <p style={{textAlign:'right', fontSize:'13px', color:'#447399'}}>Select above filter(s) and apply to view and/or download the report</p> <hr style={{borderColor:'#f7f7f7', borderWidth: '0.05px'}}/>
        <p style={{textAlign:'center', fontSize:'15.2px', color:'#447399', fontWeight:'bold', marginLeft:'2%'}}>24 Hours Analysis <br/>
          {error ? (
            <Alert severity="error">Server Error! Could not fetch the Overall system report!</Alert>
        ) : warning ? (
            <Alert severity="warning">No report data is available !</Alert>
        ) : warning1 ? (
          <Alert severity="warning">No site(s) available. Please add sites first or contact admin!</Alert>
      ): null}
        </p>
        <div className="row" style={{marginTop:'40px'}}>
          <div className="mixed-chart">
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              width="490"
              height="500"
            />
          </div>
          <div className="mixed-chart">
            <Chart
              options={this.state.options1}
              series={this.state.series1}
              type="bar"
              width="540"
              height="450"
            />
          </div>
        </div>
      </div>
      {/* Backdrop with Circular Progress */}
      <Backdrop open={this.state.open_progress_bar}>
            <div className="custom-spinner">
                <div className="circle"></div>
                <div className="circle tilted"></div>
                <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
            </div>
           </Backdrop>
      </div>

    );
  }
}

export default withNavigate(BySites);